/* eslint-disable no-undef */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { CkeditorConstants, removeNonNumberedCitationItems } from '../../src/utils';

const {
  event: { CITATIONS_DELETE_FROM_DOCUMENT, Cut, Delete, PASTE },
  MEDIA_AND_INLINE_ELEMENTS,
  htmlElement: { TABLE },
  helperAttributes: { NUMBERED_CITATION },
} = CkeditorConstants;

export default class CitationsDeletionFromDocumentEditing extends Plugin {
  init() {
    [Cut, PASTE, Delete].forEach((event) => {
      this.listenTo(this.editor.editing.view.document, event, (evt, data) => {
        if (evt?.name !== Cut) {
          if (this.hasCitationsInSelection()) {
            this.executeAction(evt, data);
          }}
        if (event === Delete) {
          const selection = this.editor.model.document.selection;
          if (selection?.getSelectedElement()?.name === TABLE) {
            data?.domEvent.preventDefault();
            data?.domEvent.stopImmediatePropagation();
            this.editor.fire('checkNumberedCitationInTable', { evt, selectedElement: selection?.getSelectedElement() });
          }
        }
      }, { priority: 'high' });
    });
  }
  
  /**
   * Checks if the current selection contains any numbered citations
   * @returns {boolean} true if citations are present in selection
   */
  hasCitationsInSelection() {
    const editor = this.editor;
    const selection = editor.model.document.selection;

    // Check if any numbered citations exist within the selection range
    const ranges = selection.getRanges();
    for (const range of ranges) {
      const items = [...range.getWalker()].filter(
        item => item.item?.name === NUMBERED_CITATION
      );
      if (items.length > 0) {
        return true;
      }
    }

    return false;
  }

  executeAction(evt, data) {
    const editor = this.editor;
    const selection = editor.model.document.selection;
    const selectedElement = selection?.getSelectedElement();
    if (
      MEDIA_AND_INLINE_ELEMENTS.indexOf(
          selectedElement?.name?.toUpperCase()
      ) > -1
    ) {
      return;
    }
    if (evt?.name !== PASTE) {
      removeNonNumberedCitationItems(this.editor);
    }
    editor.fire(CITATIONS_DELETE_FROM_DOCUMENT, { multipleRefs: { evt, data } });
  }

}
